import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { initDB } from "@/api/initdb";
export default {
  name: "Init",
  data: function data() {
    return {
      form: {
        sqlType: "mysql",
        host: "127.0.0.1",
        port: "3306",
        userName: "root",
        password: "",
        dbName: "gva"
      }
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var loading, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading = _this.$loading({
                lock: true,
                text: "正在初始化数据库，请稍候",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
              });
              _context.prev = 1;
              _context.next = 4;
              return initDB(_this.form);
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                _this.$message({
                  type: "success",
                  message: res.msg
                });
                _this.$router.push({
                  name: "login"
                });
              }
              loading.close();
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              loading.close();
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 9]]);
      }))();
    }
  }
};